import { CMSSection } from '@/features/cms/components/CMS/CMSSection'
import { type CMSPageDataWithSpecificLayout } from '@/features/cms/components/CMS/types'
import { screenSizes } from '@shipt/design-system-themes'
import styled from 'styled-components'
import { getCMSWrapperProps } from '@/features/cms/components/CMS/utils/getCMSWrapperProps'
import { useCMSParamsWithoutSlug } from '@/features/cms/services/CMS/hooks'
import { type cmsComponents } from '@/features/cms/components/CMS/CMSComponents'

/**
 * This component corresponds to the `retailer_home_page_layout` content type in the CMS.
 *
 * - **Staging** - https://cms-staging.shipt.com/content-type/pool/retailer_home_page_layout
 * - **Production** - https://cms.shipt.com/content-type/pool/retailer_home_page_layout
 */
export const RetailerHomePageLayout = ({
  layoutData: { id, content_type_id, data },
  layoutEagerComponents,
}: {
  layoutData: CMSPageDataWithSpecificLayout<'retailer_home_page_layout'>['content']
  layoutEagerComponents?: Partial<typeof cmsComponents>
}) => {
  const sectionAandB = (data?.body_section_a ?? []).concat(data?.body_section_b ?? [])
  const cmsParams = useCMSParamsWithoutSlug()

  return (
    // carousels can persist consistent data in the UI tree on shelf driven pages
    // causing only children to re-render instead of entire carousel
    <div key={cmsParams.addressParams?.address_line_1}>
      {!!data?.announcement && <CMSSection section={data.announcement} />}
      <Wrapper {...getCMSWrapperProps({ content_type_id, id })}>
        <CMSSection section={sectionAandB} layoutEagerComponents={layoutEagerComponents} />
      </Wrapper>
    </div>
  )
}
const Wrapper = styled.div`
  @media ${screenSizes.tablet} {
    margin-top: 1rem;
  }
`
